import {
  mergeDeepObjects,
  convertKeysToSnakeCaseIfAny
} from '@/plugins/helpers'

const stateKeys = {
  platform: 'postal-platform',
  data: 'postal-data'
}

const initialState = () => ({
  isStandalone: false,
  isLoading: true,
  toolName: null,
  platform: {},
  data: {}
})

export const state = () => initialState()

export const mutations = {
  clearStorage(state) {
    const freshState = JSON.parse(JSON.stringify(initialState()))
    for (const key in freshState) {
      state[key] = freshState[key]
    }
  },
  setPlatform(state, value) {
    state.platform = value
  },
  setData(state, value) {
    state.data = value
  },
  setIsLoading(state, value) {
    state.isLoading = value
  },
  setToolName(state, value) {
    state.toolName = value
  },
  setIsStandalone(state, value) {
    state.isStandalone = value
  }
}

export const actions = {
  clearStorage({ commit }) {
    // console.log('postal clearStorage')
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
    commit('clearStorage')
  },
  async setInit({ state, commit, dispatch }, json) {
    if (json) {
      if (json.platform) {
        const newJson = fallbackSupport(json)
        await dispatch('setPlatform', newJson?.platform)
      }
      if (json.data) {
        const newJson = fallbackSupport(json)
        await dispatch('setData', newJson?.data)
      }
    }
  },
  setPlatform({ state, commit }, platform) {
    if (platform) {
      commit('setPlatform', platform)
    }
  },
  setData({ state, commit }, data) {
    if (data) {
      commit('setData', mergeDeepObjects(true, state.data, data))
    }
  }
}

const fallbackSupport = (json) => {
  // For e-Care Android
  const snakeCasedData = convertKeysToSnakeCaseIfAny(json?.data)
  if (json?.data && snakeCasedData?.installation_id) {
    json.data.installation_id = snakeCasedData?.installation_id
  }
  if (json?.platform?.professional?.id) {
    json.platform.professionalId = json?.platform?.professional?.id
  }
  return json
}
